import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getCountersRequest = reatomAsync(
  async (_, { userId }: { userId: string }) => {
    return API.counterApi
      .counterControllerGetCountersByUserId(userId)
      .then((response) => response.data);
  },
  "getCountersRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());
